module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門4_4_1.167b0388.png";